import { action, observable } from 'mobx';
import { api, config } from '../config';

// Components
import SessionStore from './SessionStore';
import SettingsStore from './SettingsStore';

let obx = observable({
  registerData: {
    accountData: {}
  },
  getLocalStorage: action(function(data) {
    obx.registerData = data;
  }),
  updateAccountInfo: action(function(data) {
    for(let key in data) {
      if(data[key]) {
        var newData = data[key];
        obx.registerData.accountData[key] = newData;
        obx.registerData.accountData.username = obx.registerData.accountData.email;
      }
    }

    if(SessionStore.hasSessionStorage) {
      sessionStorage.setItem('registerData', JSON.stringify(obx.registerData));
    } else {
      document.cookie = `registerData=${JSON.stringify(obx.registerData)}`;
    }
  }),
  // Get proctor data
  getProctorData: action(function(){
    SessionStore.startLoading('Loading…', 'GetProctorData');

    api.get(`/proctors/${SessionStore.userData.proctorAccountSid}`)
      .then(response => {
        obx.registerData.accountData = response.data;
        SessionStore.finishLoading('GetProctorData');
      })
  }),
  // Create proctor account
  createProctor: action(function(func) {
    SessionStore.startLoading('Loading…', 'CreateProctor');

    let data = obx.registerData.accountData;

    data.type = "individual-proctor";

    delete data.metadata;

    api.post(`/proctors`, data)
      .then(response => {
        SessionStore.finishLoading('CreateProctor');
        SessionStore.login(obx.registerData.accountData.username, obx.registerData.accountData.password, func);
      })
      .catch(error => {
        SessionStore.throwError(error)
      });
  }),
  // Update proctor account
  updateProctor: action(function(data, callback){
    SessionStore.startLoading('Loading…', 'UpdateProctor');

    let payload = obx.registerData.accountData;

    for(let key in data) {
      if(data[key] || key === 'active') {
        payload[key] = data[key];
      }

      if(key === 'forceSetupVerification') {
        payload[key] = data[key];
      }
    }

    // Make sure testing administrator cannot be selected
    const taIndex = payload.proctorTypes.indexOf(config.testingAdministratorSid)

    if(taIndex > -1) {
      payload.proctorTypes.splice(taIndex, 1);
    }

    delete payload.sid;
    delete payload.authentication;
    delete payload.createdDate;
    delete payload.deploymentOwnerSid;
    delete payload.editDate;
    delete payload.email;
    delete payload.firstName;
    delete payload.lastName;
    delete payload.type;
    delete payload.verificationDate;
    delete payload.verifiedBy;
    delete payload.metadata;
    delete payload.image;

    if(!payload.timeZoneSid) {
      delete payload.timeZoneSid;
    }

    api.put(`/proctors/${SessionStore.userData.proctorAccountSid}`, payload)
      .then(response => {
        SessionStore.finishLoading('CreateProctor');

        SettingsStore.userSettings = response.data;

        if(callback) {
          callback()
        }
      })
      .catch(error => {
        SessionStore.throwError(error)
      });
  })
});

export default obx;



// WEBPACK FOOTER //
// ./src/app/stores/RegisterStore.js